// ServicesHeroSection.js
import * as React from "react";
import { Box, Container, Typography } from "@mui/material";

export default function ServicesHeroSection() {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        minHeight: { xs: 320, sm: 420, md: 520 },
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* Background image (like your bt_bb_background_image_holder) */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            'url("https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/hero_services.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          transform: "scale(1)",
        }}
      />

      {/* Dark overlay for readable text */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.25) 55%, rgba(0,0,0,0.0) 100%)",
        }}
      />

      <Container
        maxWidth="lg"
        sx={{ position: "relative", zIndex: 1, py: { xs: 6, md: 10 } }}
      >
        <Box sx={{ maxWidth: 720 }}>
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: 18, md: 20 },
              fontWeight: 600,
              opacity: 0.95,
              mb: 1,
              // mimic handwritten-ish label (optional)
              fontFamily:
                '"Comic Sans MS", "Segoe Script", "Brush Script MT", cursive',
            }}
          >
            Services
          </Typography>

          <Typography
            variant="h1"
            sx={{
              color: "#fff",
              fontWeight: 800,
              letterSpacing: -1,
              lineHeight: 1.05,
              fontSize: { xs: 40, sm: 54, md: 72 },
              mb: 3,
              textShadow: "0 8px 30px rgba(0,0,0,0.35)",
            }}
          >
            How Can We  help
           
            You Today?
          </Typography>

          {/* "Standard clean from $29" line + dot */}
          <Box
            sx={{
              position: "relative",
              mt: { xs: 2, md: 4 },
              width: "fit-content",
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            {/* left big dot */}
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                bgcolor: "#F59E0B",
                boxShadow: "0 10px 24px rgba(0,0,0,0.25)",
                flex: "0 0 auto",
              }}
            />

            {/* label + line + small dot */}
            <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: { xs: 16, md: 18 },
                  fontWeight: 600,
                  opacity: 0.95,
                  mr: 2,
                  fontFamily:
                    '"Comic Sans MS", "Segoe Script", "Brush Script MT", cursive',
                  textShadow: "0 6px 18px rgba(0,0,0,0.35)",
                  whiteSpace: "nowrap",
                }}
              >
                Standard charges from $29
              </Typography>

              <Box
                sx={{
                  width: { xs: 140, sm: 180, md: 220 },
                  height: 2,
                  bgcolor: "#F59E0B",
                  borderRadius: 999,
                  opacity: 0.95,
                }}
              />

              <Box
                sx={{
                  ml: 1.5,
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: "#F59E0B",
                  opacity: 0.95,
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
